import React from "react";
import { RouteObject } from "../../interfaces/navigation";
import { Navigate, useParams } from "react-router-dom";

const EntryPoint = React.lazy(() => import("../../containers/Publication/EntryPointContainer"));

const PublicationRedirect = () => {
    const { id } = useParams();
    return <Navigate to={`/autos/usados/${id}`} replace />;
};

export const publicationRoutes: RouteObject[] = [
    {
        title: "Publication Redirect",
        path: "/publicacion/:id",
        component: <PublicationRedirect />
    },
    {
        title: "Publication Redirect",
        path: "/publication/:id",
        component: <PublicationRedirect />
    },
    {
        title: "Publication ID Only",
        path: "/autos/usados/:id",
        component: <EntryPoint/>
    },
    {
        title: "Publication ID Only",
        path: "/autos/nuevos/:id",
        component: <EntryPoint/>
    },
    {
        title: "Publication Brand ID",
        path: "/autos/usados/:brand/:id",
        component: <EntryPoint/>
    },
    {
        title: "Publication Brand ID",
        path: "/autos/nuevos/:brand/:id",
        component: <EntryPoint/>
    },
    {
        title: "Publication Brand Model ID",
        path: "/autos/usados/:brand/:model/:id",
        component: <EntryPoint/>
    },
    {
        title: "Publication Brand Model ID",
        path: "/autos/nuevos/:brand/:model/:id",
        component: <EntryPoint/>
    },
    {
        title: "Publication Brand Model Description ID",
        path: "/autos/usados/:brand/:model/:description/:id",
        component: <EntryPoint/>
    },
    {
        title: "Publication Brand Model Description ID",
        path: "/autos/nuevos/:brand/:model/:description/:id",
        component: <EntryPoint/>
    }
];